import { render, staticRenderFns } from "./selectArea.vue?vue&type=template&id=0b36c92b&scoped=true"
import script from "./selectArea.vue?vue&type=script&lang=js"
export * from "./selectArea.vue?vue&type=script&lang=js"
import style0 from "./selectArea.vue?vue&type=style&index=0&id=0b36c92b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36c92b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b36c92b')) {
      api.createRecord('0b36c92b', component.options)
    } else {
      api.reload('0b36c92b', component.options)
    }
    module.hot.accept("./selectArea.vue?vue&type=template&id=0b36c92b&scoped=true", function () {
      api.rerender('0b36c92b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/personaAndCompany/personalInfo/form/components/selectArea.vue"
export default component.exports